import React, { useMemo } from "react";
import CustomSelect from "./CustomSelect";
import { IconAgent, IconPlus, IconEdit } from "./Icons";
import "./ChatHeader.css";

function Chevron({ direction = "left", open = true }) {
  const rotate = direction === "left"
    ? (open ? 0 : 180)
    : (open ? 180 : 0);
  return (
    <svg width="12" height="12" viewBox="0 0 14 14"
         style={{ transform: `rotate(${rotate}deg)`, transition: "transform 180ms ease" }}
         aria-hidden="true">
      <path d="M9 3.5 4.5 7 9 10.5" stroke="currentColor" strokeWidth="1.3"
            fill="none" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export default function ChatHeader({
  agents,
  activeAgentId,
  onAgentChange,
  onNewAgent,
  onEditAgent,
  canEditActive = false,
  activeEnvName,
  leftCollapsed = false,
  rightCollapsed = false,
  onToggleLeft,
  onToggleRight,
  disabled,
}) {
  const noAgents = agents.length === 0;
  const options = useMemo(
    () => agents.map((a) => ({
      value: a._id,
      label: a.name,
      icon: <IconAgent size={12} />,
      hint: a.description || undefined,
    })),
    [agents]
  );

  return (
    <header className="ca-chat-header">
      <div className="ca-chat-header-left">
        <button
          type="button"
          className="ca-chat-header-edge-toggle"
          onClick={onToggleLeft}
          title={leftCollapsed ? "Show chats" : "Hide chats"}
          aria-label={leftCollapsed ? "Show chats sidebar" : "Hide chats sidebar"}
        >
          <Chevron direction="left" open={!leftCollapsed} />
        </button>
        <CustomSelect
          value={activeAgentId || ""}
          options={options}
          onChange={(v) => onAgentChange(v || null)}
          placeholder={noAgents ? "No agents available" : "Select an agent…"}
          disabled={noAgents || disabled}
          ariaLabel="Select an agent"
          size="sm"
          flat
        />
        {onNewAgent && (
          <button
            type="button"
            className="ca-chat-header-edge-toggle"
            onClick={onNewAgent}
            title="New agent"
            aria-label="Create a new agent"
          >
            <IconPlus size={12} />
          </button>
        )}
        {canEditActive && onEditAgent && (
          <button
            type="button"
            className="ca-chat-header-edge-toggle"
            onClick={onEditAgent}
            title="Edit agent"
            aria-label="Edit the selected agent"
          >
            <IconEdit size={12} />
          </button>
        )}
        {activeEnvName && (
          <span className="ca-chat-header-env">
            in <span className="ca-chat-header-env-name">{activeEnvName}</span>
          </span>
        )}
      </div>
      <div className="ca-chat-header-right">
        <button
          type="button"
          className="ca-chat-header-edge-toggle"
          onClick={onToggleRight}
          title={rightCollapsed ? "Show panels" : "Hide panels"}
          aria-label={rightCollapsed ? "Show side panels" : "Hide side panels"}
        >
          <Chevron direction="right" open={!rightCollapsed} />
        </button>
      </div>
    </header>
  );
}
